import { on } from 'delegated-events'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import scrollTo from '@common/scroll-to'

gsap.registerPlugin(ScrollTrigger)

const tabPanels = {}

const closeOtherTabs = (activeTrigger) => {
  const container = activeTrigger.closest('[role="tablist"]')
  const otherTriggers = Array.from(container.querySelectorAll('[role="tab"][aria-selected="true"]')).filter(
    (x) => x !== activeTrigger
  )

  otherTriggers.forEach((x) => closeTab(x))
}

const openTab = async (trigger) => {
  const panel = document.getElementById(trigger.getAttribute('aria-controls'))

  trigger.setAttribute('aria-selected', 'true')
  panel.setAttribute('aria-hidden', 'false')

  await scrollTo(document.body)
  enableScroll(panel)
}

const closeTab = (trigger) => {
  const panel = document.getElementById(trigger.getAttribute('aria-controls'))

  trigger.setAttribute('aria-selected', 'false')
  panel.setAttribute('aria-hidden', 'true')

  disableScroll(panel)
}

const handleTab = (e) => {
  e.preventDefault()

  const trigger = e.target.closest('[role="tab"]')

  if (trigger.getAttribute('aria-selected') === 'false') {
    openTab(trigger)
    closeOtherTabs(trigger)
  }
}

const enableScroll = (tabPanel) => {
  const timelines = tabPanels[tabPanel.id]

  timelines.forEach((x) => x.scrollTrigger.enable())
}

const disableScroll = (tabPanel) => {
  const timelines = tabPanels[tabPanel.id]

  timelines.forEach((x) => x.scrollTrigger.disable())
}

on('click', '[data-tablist] [role="tab"]', handleTab)

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[role="tabpanel"]').forEach((tabPanel) => {
    const section = tabPanel.querySelector('.list-section')
    const blocks = section.querySelectorAll('.list-block')

    gsap.set(section.querySelectorAll('.list-icon'), { x: '-100vw' })
    gsap.set(section.querySelectorAll('.list-content'), { x: '100vw' })
    gsap.set(section.querySelectorAll('.list-indicator'), { opacity: 0 })

    section.classList.remove('invisible')

    const timelines = []

    blocks.forEach((block) => {
      const timeline = gsap.timeline({
        paused: true,
        scrollTrigger: {
          trigger: block,
          start: 'top center',
          markers: false,
        },
      })

      timeline.to(block.querySelector('.list-indicator'), {
        opacity: 1,
        duration: 0.4,
      })

      timeline.to(
        block.querySelector('.list-icon'),
        {
          x: 0,
          duration: 0.8,
          ease: 'power4',
        },
        '<'
      )

      timeline.to(
        block.querySelector('.list-content'),
        {
          x: 0,
          duration: 0.8,
          ease: 'power4',
        },
        '<'
      )

      timeline.scrollTrigger.disable()

      timelines.push(timeline)
    })

    tabPanels[tabPanel.id] = timelines
  })

  const activeTabPanel = document.querySelector('[role="tabpanel"][aria-hidden="false"]')
  enableScroll(activeTabPanel)
})
